
































import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    BaseButton
  }
})
export default class CourseCancellationConfirmationModal extends Vue {
  @Prop({ type: Function, default: () => {} })
  readonly confirmDelete!: () => void;
  @Prop({ type: String, default: '' }) readonly courseName!: string;

  @Emit('close')
  closeModal() {
    return;
  }

  @Emit('confirmDelete')
  handleConfirmDelete() {
    this.confirmDelete();
    return;
  }
}
